import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,
        dataTableOptions: {
            server_mode: false,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            // {
            //     btn_text: '<i class="fas fa-filter"></i> Szűrés',
            //     event_name: "customClick",
            //     class: "btn btn-danger my-custom-class",
            //     event_payload: 'showSearchModal'
            // },
            {
                btn_text: '<i class="fas fa-download"></i> Exportálás',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'exportData'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Adatok',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'seeDataAssInvPerUser'
            }
        ],
        searchFields: [
            {
                name: "username",
                label: "Felhasználónév",
                formSize: 3,
                formType: 'text'
            },
            {
                name: "firstName",
                label: "Vezetéknév",
                formSize: 3,
                formType: 'text'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: true,
                filter: {
                    type: "simple",
                },
                uniqueId: true,
                formType: 'text',
                formReadOnly: true,
                formSize: 4,
                visibility: false,
                formVisible: false
            },
            {
                name: "username",
                label: "Felhasználónév",
                sort: true,
                filter: {
                    type: "simple",
                },
                formType: 'text',
                formSize: 3,
                formVisible: false
            },
            {
                name: "firstName",
                label: "Vezetéknév",
                sort: true,
                filter: {
                    type: "simple",
                },
                formType: 'text',
                formSize: 3,
                formVisible: false
            },
            {
                name: "lastName",
                label: "Kereszt név",
                sort: true,
                filter: {
                    type: "simple",
                },
                formType: 'text',
                formSize: 3,
                visibility: true,
                formVisible: false
            },
            {
                name: "dateOfBirth",
                label: "Születési dátum",
                slot_name: "date_format",
                sort: true,
                filter: {
                    type: "simple",
                },
                formType: 'date',
                formSize: 3,
                visibility: true,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ],
        dataAssInvFormIsOpen: false,
        dataAssInvGridIsOpen: true,
        dataAssInvDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        dataAssInvActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModalDataAssInv'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új adatvagyonleltár',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newRowDataAssInv'
            }
        ],
        dataAssInvFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToDataAssInvGrid'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary my-custom-class mx-1",
                event_payload: 'resetDataAssInvForm'
            }
        ],
        dataAssInvRowActions: [
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Szerkesztés',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'modifyDataAssInvRow'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteDataAssInvRow'
            }
        ],
        dataAssInvSearchFields: [
            {
                name: "gdprId",
                label: "GDPR azonosító",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
            {
                name: "dataManagementGoal",
                label: "Adatkezelési cél",
                formSize: 3,
                formVisible: true,
                formType: 'text'
            },
        ],
        dataAssInvHeaderFields: [
            {
                name: "id",
                label: "ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "userId",
                label: "User ID",
                visibility: false,
                formVisible: false
            },
            {
                name: "userTypeId",
                label: "Alkalmazott típus",
                filter: {
                    type: "simple",
                },
                sort: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getUserPersonTypeFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                },
                formSize: 4,
                visibility: false,
                formRequired: true,
                formVisible: true
            },
            {
                name: "gdprId",
                label: "GDPR azonosító",
                sort: true,
                formVisible: false
            },
            {
                name: "dataManagementGoal",
                label: "Adatkezelési cél",
                sort: true,
                visibility: true,
                formType: 'text',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "storageTime",
                label: "Tárolási idő (év)",
                sort: true,
                visibility: true,
                formType: 'number',
                formSize: 4,
                formRequired: true,
                formVisible: true
            },
            {
                name: "employmentStartDate",
                label: "Jogviszony kezdete",
                slot_name: "authenticationTime_format",
                sort: true,
                formType: 'date',
                formSize: 4,
                visibility: true,
                formVisible: true,
                formRequired: false
            },
            {
                name: "employmentEndDate",
                label: "Jogviszony vége",
                slot_name: "authenticationTimeTo_format",
                sort: true,
                formType: 'date',
                formSize: 4,
                visibility: true,
                formVisible: true,
                formRequired: false
            },
            {
                name: "storageStatus",
                label: "Tárolás státusza",
                visibility: false,
                formSize: 4,
                formVisible: true,
                formType: 'select',
                selectOptions: {
                    apiCallback: Api.getAllStorageStatusFilter,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataManagementPlaces",
                label: "Tárolási helyek",
                visibility: false,
                formSize: 4,
                formRequired: false,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllDataManagementProcessPlace,
                    formatOption: function (val) {
                        return val.dataManagementPlace;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'dataManagementPlace',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "personalDataCategories",
                label: "Kezelt személyes adatok kategóriái",
                visibility: false,
                formSize: 4,
                formRequired: false,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllPersonalDataCategoryFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "dataSources",
                label: "Adatforrások",
                visibility: false,
                formSize: 4,
                formRequired: false,
                formVisible: true,
                formType: 'checkboxes',
                checkboxesOptions: {
                    apiCallback: Api.getAllDataSourceFilter,
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdBy",
                label: "Készítő",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedBy",
                label: "Módosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "createdOn",
                label: "Készítés dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "modifiedOn",
                label: "Módosítás dátuma",
                visibility: false,
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            },
        ]
    }
}
